import { initGraphQLTada } from 'gql.tada'
import type { introspection } from './visitor-env'

// todo: API 전체 교체하고 나면 graphQL 코드 없애기
export const graphql = initGraphQLTada<{
    introspection: introspection
}>()